var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.42 41.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "check-circle",
    d: "M20.71,0A20.71,20.71,0,1,0,41.42,20.71h0A20.71,20.71,0,0,0,20.72,0Zm-2.1,27.72a1,1,0,0,1-1.39,0h0l-5.56-5.57a1.48,1.48,0,0,1,0-2.1h0l.7-.7a1.49,1.49,0,0,1,2.09,0h0l3.48,3.48,9.4-9.4a1.49,1.49,0,0,1,2.09,0l.7.7a1.48,1.48,0,0,1,0,2.1h0Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.3fda32249b964a68dfff01c889dfb1b9.svg";
export { ForwardRef as ReactComponent };